import type { DraftFinalizeUpdates } from "@/services/invoiceUploadService";
import type { DraftFormValues } from "@/components/upload/draftFormSchema";

function parseJsonField(value: string | undefined): unknown {
  return value ? JSON.parse(value) : undefined;
}

/**
 * What finalizing a draft sends, from the submitted form. `null` when a sales-report table holds
 * JSON that does not parse.
 */
export function buildFinalizeUpdates(data: DraftFormValues): DraftFinalizeUpdates | null {
  const updates: DraftFinalizeUpdates = {
    vendor: data.vendor || undefined,
    amount: data.amount,
    currency: data.currency,
    dueDate: data.dueDate || undefined,
    transactionDate: data.transactionDate || undefined,
    remittanceInformation: data.remittanceInformation || undefined,
    vendorAccountFields: {
      vendor_iban: data.vendorIban || null,
      vendor_bankgiro: data.vendorBankgiro || null,
      vendor_plusgiro: data.vendorPlusgiro || null,
      vendor_account_number: data.vendorAccountNumber || null,
      vendor_clearing_number: data.vendorClearingNumber || null,
    },
    bankBic: data.bankBic || undefined,
    bankName: data.bankName || undefined,
    paymentMethod: data.paymentMethod || undefined,
    expenseCategory: data.expenseCategory || undefined,
    documentType: data.documentType,
    categoryMetadata: data.participants && data.participants.length > 0
      ? { participants: data.participants }
      : undefined,
  };

  if (data.documentType !== "sales_report") return updates;

  updates.reportDate = data.reportDate || undefined;
  updates.totalGrossSales = data.totalGrossSales || undefined;
  updates.totalReturns = data.totalReturns || undefined;
  updates.totalNetSales = data.totalNetSales || undefined;
  try {
    updates.vatSummary = parseJsonField(data.vatSummary);
    updates.paymentMethodsData = parseJsonField(data.paymentMethods);
    updates.salesCategories = parseJsonField(data.salesCategories);
  } catch {
    return null;
  }
  return updates;
}
